import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { insertBatch, getHouseList, selectManagerArea } from "@/api/PMS/baseInformation/meterManager";
import { fetchList as getMeterTypeList } from "@/api/PMS/baseInformation/meterType";
import { getGroupList, getBuildingList } from "@/api/PMS/chargeManagement/frountDeskCharge/prepay";
import { fetchListByType } from "@/api/system/dic/dic";
export default {
  data: function data() {
    var _this = this;

    var validatePassGroup = function validatePassGroup(rule, value, callback) {
      if (parseInt(_this.chooseType) >= 1 && value === undefined) {
        callback(new Error("请选择区域!"));
      } else {
        callback();
      }
    };

    var validatePassBuilding = function validatePassBuilding(rule, value, callback) {
      if (parseInt(_this.chooseType) >= 1 && value === undefined) {
        callback(new Error("请选择楼栋!"));
      } else {
        callback();
      }
    };

    var validatePassHouse = function validatePassHouse(rule, value, callback) {
      if (parseInt(_this.chooseType) >= 2 && value === undefined) {
        callback();
      } else {
        callback();
      }
    };

    var validatePassMeterType = function validatePassMeterType(rule, value, callback) {
      if (parseInt(_this.chooseType) >= 2 && value === undefined) {
        callback();
      } else {
        callback();
      }
    };

    return {
      rules: {
        areaGroupId: [{
          required: true,
          validator: validatePassGroup,
          trigger: "blur"
        }],
        areaId: [{
          required: true,
          message: "请选择小区名称",
          trigger: "change"
        }],
        buildingId: [{
          required: true,
          trigger: "change",
          validator: validatePassBuilding
        }],
        houseIds: [{
          required: true,
          trigger: "blur",
          validator: validatePassHouse
        }],
        meterTypeList: [{
          required: true,
          message: "请选择仪表类型",
          validator: validatePassMeterType
        }]
      },
      chooseType: 0,
      meterTypeList: [],
      houseList: [],
      areaList: [],
      groupList: [],
      buildingList: [],
      houseStatusList: [],
      houseTypeList: [],
      listQuery: {},
      listLoading: false,
      listLoadingTwo: false,
      multipleSelection: [],
      multipleMeterSelection: [],
      childData: {}
    };
  },
  props: ["keyValue", "showDialog"],
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
      });
      this.childData = {};
      this.multipleSelection = [];
      this.multipleMeterSelection = [];
      this.houseList = [];
      this.meterTypeList = [];
      this.chooseType = "0";
      this.loadMeterTypeList();
      this.loadAreaList();
      this.getHouseType();
      this.getHouseStatus();
    },
    // 获取仪表类型
    loadMeterTypeList: function loadMeterTypeList() {
      var _this3 = this;

      this.listLoadingTwo = true;
      getMeterTypeList({}).then(function (r) {
        _this3.listLoadingTwo = false;
        _this3.meterTypeList = r.data.data;
        console.log(_this3.meterTypeList, '2222222');
      });
    },
    handCreate: function handCreate() {
      var _this4 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          // 组装数据
          _this4.childData.batchType = parseInt(_this4.chooseType);

          if (_this4.childData.batchType === 0) {
            _this4.childData.batchId = _this4.childData.areaId;
          }

          if (_this4.childData.batchType === 1) {
            _this4.childData.batchId = _this4.childData.buildingId;
          }

          if (_this4.childData.batchType === 2) {
            _this4.childData.houseIds = [];

            _this4.multipleSelection.forEach(function (item) {
              _this4.childData.houseIds.push(item.houseId);
            });

            if (_this4.childData.houseIds.length <= 0) {
              return _this4.Alert({
                alertType: "valid",
                message: "请选择房屋！"
              });
            }
          }

          _this4.childData.meterTypeList = [];

          _this4.multipleMeterSelection.forEach(function (item) {
            var data = {
              meterId: item.meterId,
              meterName: item.meterName
            };

            _this4.childData.meterTypeList.push(data);
          });

          if (_this4.childData.meterTypeList.length <= 0) {
            return _this4.Alert({
              alertType: "valid",
              message: "请选择仪表！"
            });
          }

          insertBatch(_this4.childData).then(function (response) {
            if (response.data.code === 200) {
              _this4.$emit("handCancle", true);

              _this4.Alert({
                alertType: "add"
              });
            }
          });
        } else {
          _this4.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    },
    // 点击切换tab
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取小区名称
    loadAreaList: function loadAreaList() {
      var _this5 = this;

      selectManagerArea({}).then(function (r) {
        _this5.areaList = r.data.data;
      });
    },
    // 获取区域分组
    loadGroupList: function loadGroupList() {
      var _this6 = this;

      getGroupList({
        areaId: this.childData.areaId
      }).then(function (r) {
        _this6.groupList = r.data.data;
        _this6.childData.areaGroupId = _this6.groupList[0].areaGroupId;
        console.log();
        console.log("groupList", _this6.groupList);

        if (_this6.childData.buildingId) {
          delete _this6.childData.buildingId;
        }

        if (_this6.childData.houseId) {
          delete _this6.childData.houseId;
        }

        _this6.listQuery = {};
        _this6.buildingList = [];
        _this6.houseList = [];

        if (_this6.childData.areaGroupId) {
          _this6.loadBuildingList();
        }
      });
    },
    // 小区名称更新触发
    areaChange: function areaChange() {
      // 清理房间id,楼栋id
      if (this.childData.areaGroupId) {
        delete this.childData.areaGroupId;
      }

      if (this.childData.buildingId) {
        delete this.childData.buildingId;
      }

      if (this.childData.houseId) {
        delete this.childData.houseId;
      }

      this.groupList = [];
      this.buildingList = [];
      this.houseList = [];
      console.log(this.childData.areaId);

      if (this.childData.areaId) {
        this.loadGroupList();
      }
    },
    // 区域分组更新时触发
    groupChange: function groupChange() {// 清理房间id,楼栋id
    },
    // 获取楼栋集合
    loadBuildingList: function loadBuildingList() {
      var _this7 = this;

      getBuildingList({
        areaGroupId: this.childData.areaGroupId
      }).then(function (r) {
        _this7.buildingList = r.data.data;
      });
    },
    // 楼栋更新时触发
    buildingChange: function buildingChange() {
      // 清理房间id
      if (this.childData.houseId) {
        delete this.childData.houseId;
      }

      this.listQuery = {}; // 清理房间集合

      this.houseList = [];

      if (this.childData.buildingId) {
        this.loadHouseList();
      }
    },
    // 获取房屋集合
    loadHouseList: function loadHouseList() {
      var _this8 = this;

      this.listLoading = true;
      var query = {
        id: this.childData.buildingId,
        dataType: 2
      };

      if (this.listQuery.houseType) {
        query.houseType = this.listQuery.houseType;
      }

      if (this.listQuery.houseStatus) {
        query.houseStatus = this.listQuery.houseStatus;
      }

      if (this.listQuery.houseCode) {
        query.houseCode = this.listQuery.houseCode;
      }

      getHouseList(query).then(function (r) {
        _this8.houseList = r.data.data;
        _this8.listLoading = false;
      });
    },
    getHouseType: function getHouseType() {
      var _this9 = this;

      fetchListByType("house_type").then(function (r) {
        _this9.houseTypeList = r.data.data;
      });
    },
    getHouseStatus: function getHouseStatus() {
      var _this10 = this;

      fetchListByType("house_status").then(function (r) {
        _this10.houseStatusList = r.data.data;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleMeterSelectionChange: function handleMeterSelectionChange(val) {
      this.multipleMeterSelection = val;
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};